export default "__VITE_ASSET__60e2b89b__"